var ComponentType;
(function (ComponentType) {
    ComponentType["AGGREGATOR"] = "Aggregator";
    ComponentType["BEHAVIOR"] = "Behavior";
    ComponentType["DATA_DISPLAY"] = "DataDisplay";
    ComponentType["DATA_ENTRY"] = "DataEntry";
    ComponentType["FEEDBACK"] = "Feedback";
    ComponentType["FORM"] = "Form";
    ComponentType["LAYOUT"] = "Layout";
    ComponentType["LIST"] = "List";
    ComponentType["NAVIGATION"] = "Navigation";
})(ComponentType || (ComponentType = {}));
export { ComponentType, };
export default ComponentType;
//# sourceMappingURL=component-type.js.map